/* src/app/shared/dialogs/autolock-warning-dialog/autolock-warning-dialog.component.scss */
:host {
  overflow: none;
}
::ng-deep .warning mat-dialog-container {
  overflow: hidden;
  border-radius: 30px;
  padding: 0px;
  background-color: #ffffff;
}
.dialog-container {
  padding-left: 10px;
  padding-right: 20px;
  width: 200px;
  height: 60px;
  position: relative;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  align-content: center;
}
.first {
  position: relative;
  width: 40px;
}
.first .animation {
  display: block;
  width: 100%;
  height: auto;
}
.first .image {
  width: 17px;
  height: 23px;
  object-fit: contain;
  position: absolute;
  top: 8px;
  left: 12px;
}
/*# sourceMappingURL=autolock-warning-dialog.component.css.map */
